/**
 * Used by Discovery pages this logic redirects (301) the current request into the US sub folder path
 *
 * For example:
 * /running-events/in-california > /us/running-events/in-california
 * /triathlon-events/olympic/in-california > /us/triathlon-events/olympic/in-california
 *
 */
function redirectToUSfolder(nextState, replace) {
  const reqUrl = nextState.location.pathname;

  if (['gb', 'us', 'au'].indexOf(reqUrl.substr(1, 2)) === -1) {
    replace({
      pathname: `/us${reqUrl}`,
    });
  }
}

/**
 *
 * @param url {String} starting with /
 * @param localeIso2
 * @returns {*}
 */
function getLocaleRouteUrl(url = '/', localeIso2) {
  let resultUrl = url;
  if (url.charAt(0) !== '/') {
    resultUrl = `/${url}`;
  }

  if (!localeIso2) {
    return resultUrl;
  }
  resultUrl = `/${localeIso2.toLowerCase()}${resultUrl}`;

  return resultUrl;
}

module.exports = {
  getLocaleRouteUrl,
  redirectToUSfolder,
};
